<template>
    <div>
        <el-dialog :title="status == 1 ? '添加合同业绩分配' : '编辑合同业绩分配'" :visible.sync="isAppendAdd" center :before-close="onClose" width="1200px" :close-on-click-modal="false">
            <el-row :gutter="20">
                <el-col :span="24" v-if="status != 1">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            电商合同号：
                        </div>
                        <div>
                            <el-input v-model="params.Distribute_OrderSN" clearable class="el-select-max" disabled></el-input>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            计算区间：
                        </div>
                        <el-date-picker v-model="date" type="daterange" style="width: 440px" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">添加业务员：</div>
                        <div><el-button type="primary" @click="getSelectOffice(true)">添加办事处</el-button></div>
                    </div>
                </el-col>

                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label"></div>
                        <div style="width: 1000px">
                            <el-table :data="office_management" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                <el-table-column prop="DistributeMain_ERPOrderSN" label="序号" width="80" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Distribute_OfficeCode" label="办事处编码" width="150" align="center">
                                    <template slot="header">
                                        办事处编码
                                        <span style="color: red">*</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="DistributeMain_ProjectName" label="业务员编码" align="center" width="200">
                                    <template slot="header">
                                        业务员编码
                                        <span style="color: red">*</span>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.Distribute_OfficeMemberCode" placeholder="请选择" class="el-select-medium" clearable @change="onchange($event, scope.row)">
                                            <el-option v-for="item in scope.row.Member" :key="item.Code" :label="item.Code + item.owername" :value="item.Code"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Distribute_OfficeMemberName" label="业务员姓名" align="center" show-overflow-tooltip>
                                    <template slot="header">
                                        业务员姓名
                                        <span style="color: red">*</span>
                                    </template>
                                    <template slot-scope="scope">
                                        {{ scope.row.Distribute_OfficeMemberName }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Distribute_Rate" label="权重比例" align="center" width="200">
                                    <template slot="header">
                                        权重比例
                                        <span style="color: red">*</span>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.Distribute_Rate" clearable class="el-select-medium"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="DistributeMain_OrdersOfficeManName" label="是否主业务员" width="120" align="center">
                                    <template slot-scope="scope">
                                        <el-radio v-model="selectedRowId" :label="scope.$index">&nbsp;</el-radio>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="DistributeMain_ERPOrderSN" label="操作" width="80" align="center">
                                    <template slot-scope="scope">
                                        <div class="operation-bar">
                                            <span class="operation-bar-block operation-bar-block-del" @click="getofficeDel(scope.$index)">删除</span>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <span slot="footer" class="dialog-footer">
                <el-button @click="onClose()">取 消</el-button>
                <el-button type="primary" @click="onSubmit()">保存</el-button>
            </span>
        </el-dialog>

        <el-dialog title="办事处选择-用户配置" :visible.sync="isShowdialog" width="800px" :before-close="onCloseOffice" :close-on-click-modal="false">
            <div class="client">
                <div class="client-head">
                    <el-input v-model="keyword" clearable class="el-select-max" placeholder="请输入办事处名称"></el-input>
                    <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="getSelectOffice(false)">检索</el-button>
                </div>
                <el-table :data="office_list" border height="40vh" :header-cell-style="{ backgroundColor: '#F5F7FA' }" ref="multipleTable" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" align="center" width="55"></el-table-column>
                    <el-table-column prop="Number" label="办事处编码" align="center"></el-table-column>
                    <el-table-column prop="Name" label="办事处名称" align="center"></el-table-column>
                    <el-table-column prop="Sys_State_ERPCode" label="省份" align="center"></el-table-column>
                    <el-table-column prop="Sys_City_ERPCode" label="城市" align="center"></el-table-column>
                </el-table>
            </div>

            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="onCloseOffice()">取消</el-button>
                <el-button type="primary" @click="onSaveOffice()">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { cloneDeep, debounce } from 'lodash';
import Hwupload from '@/components/Hwupload/index.vue';

export default {
    components: {
        Hwupload
    },
    props: {
        isAppendAdd: {
            type: Boolean,
            default: false
        },
        status: {
            type: Number,
            default: 1
        },
        id: {
            type: Number,
            default: 0
        },
        Distribute_ERPOrderSN: {
            type: String,
            default: ''
        }
    },
    watch: {
        isAppendAdd(newval, oldval) {
            if (newval) {
                (this.date = [new Date('2017-01-01'), new Date('9999-01-01')]), (this.selectedRowId = 0);
                this.params = {
                    Distribute_ERPOrderSN: this.Distribute_ERPOrderSN,
                    Distribute_ValidStartDate: '2017-01-01',
                    Distribute_ValidEndDate: '9999-01-01',
                    DistributeMain_CertUrl: '',
                    DistributeMain_CertRemark: '',
                    Distribute_IsMain: 1
                };
                this.office_list = [];
                this.office_management = [];
                this.multipleSelection = [];
                if (this.status == 2) {
                    this.EditSPCOrdersPerformanceDistribute(this.id);
                }
            }
        }
    },
    data() {
        return {
            date: [new Date('2017-01-01'), new Date('9999-01-01')],
            keyword: '',
            isShowdialog: false,
            selectedRowId: 0,
            params: {
                Distribute_ERPOrderSN: this.Distribute_ERPOrderSN,
                Distribute_ValidStartDate: '',
                Distribute_ValidEndDate: '',
                DistributeMain_CertUrl: '',
                DistributeMain_CertRemark: '',
                Distribute_IsMain: 1
            },
            office_list: [],
            office_management: [],
            multipleSelection: []
        };
    },
    methods: {
        // 修改添加
        onSubmit: debounce(function () {
            let params = {};
            if (this.date && this.date.length > 0) {
                params.Distribute_ValidStartDate = this.date[0];
                params.Distribute_ValidEndDate = this.date[1];
            }
            params.Distribute_OrderSN = this.params.Distribute_OrderSN;
            params.Distribute_ID = this.id;
            params.Distribute_IsMain = this.selectedRowId;
            params.Distribute_OfficeCode = this.office_management.map((item) => item.Distribute_OfficeCode).join(',');
            params.Distribute_OfficeMemberCode = this.office_management.map((item) => item.Distribute_OfficeMemberCode).join(',');
            params.Distribute_OfficeMemberName = this.office_management.map((item) => item.Distribute_OfficeMemberName).join(',');
            params.Distribute_Rate = this.office_management.map((item) => item.Distribute_Rate).join(',');

            console.log(params, 'paramsparams');
            this.$newsApi.AddSPCOrdersPerformanceDistribute({ type: this.status == 1 ? 'add' : 'edit', json: JSON.stringify(params) }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.$message({
                        type: 'success',
                        message: '操作成功',
                        onClose: () => {
                            this.$emit('onClose', true);
                            // 这里是提示关闭后的回调函数
                        }
                    });
                }
            });
        }, 800),
        EditSPCOrdersPerformanceDistribute(id) {
            this.$newsApi.EditSPCOrdersPerformanceDistribute({ id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    console.log(res.data.data, '========');
                    this.params = res.data.data;
                    this.date = [this.params.Distribute_ValidStartDate, this.params.Distribute_ValidEndDate];
                    this.office_management = this.params.SPCList;
                    if (this.office_management && this.office_management.length > 0) {
                        this.selectedRowId = this.office_management.findIndex((item) => item.Distribute_IsMain == 1);
                    } else {
                        this.selectedRowId = 0;
                    }
                }
            });
        },

        //获取办事处列表
        getSelectOffice(flag) {
            if (flag) {
                this.isShowdialog = true;
                this.multipleSelection = [];
                this.keyword = '';
            }
            this.$newsApi.getSelectOffice({ json: JSON.stringify({ keyword: this.keyword }) }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.office_list = res.data.data;
                }
            });
        },
        // 多选
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection, 'this.multipleSelectionthis.multipleSelection');
        },

        //关闭
        onCloseOffice() {
            this.isShowdialog = false;
        },
        async onSaveOffice() {
            let office_management = this.multipleSelection;
            try {
                // 创建每个请求的 Promise 数组
                const requests = office_management.map((item) => {
                    item.Distribute_OfficeCode = item.Number;
                    return this.getOfficeMemberSelect(item.Number);
                });
                // 使用 Promise.all 等待所有请求完成
                const values = await Promise.all(requests);
                console.log(values, 'valuesvalues');
                // 将返回的值整合回表格数据
                office_management = office_management.map((item, index) => {
                    return {
                        ...item,
                        Member: values[index], // 将接口获取的 value 值赋值给表格数据中的相应项
                        Distribute_Rate: '',
                        Distribute_OfficeMemberName: '',
                        Distribute_OfficeMemberCode: '',
                        Distribute_IsMain: 1
                    };
                });
                this.office_management = [...this.office_management, ...office_management];
                this.isShowdialog = false;
            } catch (error) {
                alert(error);
                console.error('Error fetching values:', error);
            }

            console.log(this.office_management, '1');
        },
        onchange(event, row) {
            const obj = row.Member.find((item) => item.Code == event);
            console.log(obj);
            if (obj) {
                row.Distribute_OfficeMemberName = obj.owername;
            }
        },
        getofficeDel(index) {
            this.office_management.splice(index, 1);
            console.log(this.office_management, index);
        },
        async getOfficeMemberSelect(Officecode) {
            const res = await this.$newsApi.getOfficeMemberSelect({ Officecode });
            return res.data.data;
        },
        onClose() {
            this.$emit('onClose');
        }
    }
};
</script>

<style lang="scss" scoped>
.required {
    color: red;
    margin-left: 4px;
}

.hw-addcontent-footer {
    margin-top: 20px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.client {
    margin-bottom: 20px;

    .client-head {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
}

.transfermoney {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    &-block {
        width: 220px;
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0; // No need for 'px' as it's a zero value
        }
    }
}

.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 120px;
    }
}
</style>
